import { AssetType, IBroker, IQuoteRequest, ISchedule } from '@takectrl-multiapp/svcs-share-config';

export interface IUser {
  account_details?: IAccountDetails;
  account_details_id?: string;
  broker_id?: number;
  created_time?: string;
  firebase_uuid?: string;
  id?: number;
  insurance_history?: IInsuranceHistory;
  insurance_history_id?: number;
  is_deleted?: boolean;
  modified_time?: string;
  personal_details?: IPersonalDetails;
  personal_details_id?: number;
  providers?: IProviders;
  providers_id?: null;
  broker?: IBroker;
  user_permissions?: IUserPermission;
  customerNumber?: string;
  role_name?: string;
  role_id?: number;
  user_logins?: Array<IUserLogins>;
}

export interface IUserLogins {
  id?: number;
  login_date_time?: string;
  user_id?: number;
}

export interface IAddresses {
  user_id?: number;
  active?: boolean;
  address_type?: string;
  id?: number;
  asset_type?: AssetType;
  asset_id?: number;
  postal_code?: string;
  risk_address_code?: string;
  risk_address_code_id?: string;
  risk_address_code_id_mnfg?: string;
  risk_address_code_id_sa02?: string;
  risk_address_line1?: string;
  risk_address_line2?: string;
  //new
  city?: string;
  country?: string;
  district?: string;
  latitude?: number;
  longitude?: number;
  province?: string;
  street_name?: string;
  street_number?: string;
  suburb?: string;
  unit_number?: string,
  sectional_title?: string,
  estate?: string,
}

export interface IPersonalDetails {
  address_id?: number;
  address?: IAddresses;
  id?: number;
  user_id?: number;
  casa_employment_status_code?: string;
  casa_employment_status_description?: string;
  casa_nationality_code?: string;
  casa_nationality_description?: string;
  casa_occupation_code?: string;
  casa_occupation_description?: string;
  casa_source_of_income_code?: string;
  casa_source_of_income_description?: string;
  conducting_business_from_home?: boolean;
  country_of_birth_code?: string;
  country_of_birth_description?: string;
  country_of_residence_code?: string;
  country_of_residence_description?: string;
  email?: string;
  has_pensioner_status?: boolean;
  id_nr?: string;
  language?: string;
  marital_status?: string;
  name?: string;
  nationality?: string;
  occupation?: string;
  occupation_id?: string;
  surname?: string;
  surname_on_id?: string;
  is_completed?: boolean;

  cell_nr?: string;
  created_time?: null;
  modified_time?: null;
  regular_driver_license_date?: null;
  regular_driver_license_expiry_date?: null;
  regular_driver_license_type?: null;
  regular_driver_physically_disabled?: null;
  university_degree?: null;
}

export interface IInsuranceHistory {
  is_completed?: boolean;
  id?: number;
  user_id?: number;
  claims_in1_year?: string;
  claims_in5_years?: string;
  losses_in3_years?: string;
  previous_insurance?: boolean;
  convicted_of_offence?: boolean;
  has_an_application_for_insurance_been_declined?: boolean;
  has_an_insurer_applied_special_conditions?: boolean;
  has_policy_lapsed_due_to_non_payment?: boolean;
  has_insurance_declined_cancelled_refused_imposed_conditions?: boolean;
  insurance_cancelled_refused?: boolean;
  length_of_continuous_previous_insurance?: string;
  length_of_previous_insurance?: number;
  litigation_or_judgement?: boolean;
  period?: string;
  insurance_history?: string;
  previous_insurer_expiry_date?: string;
  previous_policy_number?: string;
  renewal_period?: string;
  special_conditions?: boolean;
  created_time?: any;
  driving_offence?: any;
  modified_time?: any;
  previous_insurer?: any;
  uninterrupted_cover?: string;
}

export interface IProviders {
  brolink_client_id?: string;
  id?: number;
  intercom_id?: string;
  intercom_user_id?: string;
  miway_client_id?: string;
  peerless_client_id?: null;
  user_id?: number;
  premia_client_id?: string;
}

export interface IAccountDetails {
  account_type?: string;
  ctrl_client_timestamp?: string;
  hard_of_hearing?: boolean;
  signup_code?: string;
  user_referral_code?: string;
  source?: string;
  fcm_token?: string;
  ctrl_consent_check?: boolean;
  ctrl_consent_timestamp?: number;
  client_data_processing_consent?: number,
  client_privacy_policy_consent?: number,
  itc_check?: boolean;
  itc_check_timestamp?: number;
  popia_consent?: boolean;
  popia_consent_timestamp?: number;
  popia_consent_message?: string;
  communication_call?: string;
  communication_email?: string;
  communication_intercom?: string;
  communication_sms?: string;
  communication_whatsapp?: string;
  created_time?: string;
  ctrl_consent_time_stamp?: string;
  id?: number;
  user_id?: number;
}

export interface IUserFile {
  url: string;
  name: string;
  modeified: number;
}

export interface IUserFiles {
  files: Array<IUserFile>;
}

export interface IUserDataSubscription {
  addresses?: number;
  all_risks?: number;
  buildings?: number;
  caravans?: number;
  contents?: number;
  motorcycles?: number;
  quote_requests?: number;
  quotes?: number;
  schedules?: number;
  specified_items?: number;
  users?: number;
  users_account_details?: number;
  users_personal_details?: number;
  vehicles?: number;
}

export interface IUserAllRelatedData {
  endorsements: [];
  quote_requests: IQuoteRequest[];
  renewals: [];
  schedules: ISchedule[];
  user: IUser;
}

export interface IUserPermission {
  intercom: boolean;
  use_whatsapp_widget: boolean;
  phone_broker: boolean;
  can_quote: boolean;
  phone_insurer: boolean;
  amend_asset_on_policy: boolean;
  accept_amend_asset_on_policy: boolean;
  add_asset_to_policy: boolean;
  accept_add_asset_to_policy: boolean;
  delete_asset_from_policy: boolean;
  phone: boolean;
  in_app_chat: boolean;
}

export interface IUserResetPassword {
  message?: string;
  status?: number;
  success?: boolean;
}

export interface IFileRules {
  types: Array<string>
  max_size: number
}